import Combobox, { ComboboxOption } from "./combobox"
import { FieldValues, UseControllerProps, useController } from "react-hook-form"

import React from "react"

type SelectProps = {
    options: ComboboxOption[]
    height?: number
    maxHeight?: number
    placeholder?: string
    width?: number | string
    variant?: string
    autoSize?: boolean
    label?: string
    onChange?: (value: string | number) => void
    required?: boolean
}

const Select = <T extends FieldValues>({
    name,
    control,
    rules,
    defaultValue,
    shouldUnregister,
    options,
    height,
    maxHeight,
    placeholder,
    width,
    variant,
    autoSize,
    label,
    onChange: onChangeProp,
    required,
}: SelectProps & UseControllerProps<T>) => {
    const {
        field: { onChange, value, ref, ...rest },
        fieldState: { error },
    } = useController({
        name,
        control,
        rules,
        defaultValue,
        shouldUnregister,
    })

    return (
        <Combobox
            options={options}
            value={value}
            onSelect={selected => {
                onChange(selected)
                onChangeProp && onChangeProp(selected)
            }}
            id={name}
            label={label}
            placeholder={placeholder}
            required={required}
            width={width}
            height={height}
            maxHeight={maxHeight}
            autoSize={autoSize}
            inputRef={ref}
            inputProps={rest}
            className={variant}
            error={error}
        />
    )
}

export default Select
